import AllEmailTemplates from "../../components/email-templates";

const EmailTemplates = () => <AllEmailTemplates />
export default EmailTemplates;